import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__set-value-on-click';
export class SetValueOnClick {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        this.initActions($element);
    }
    static initActions($element) {
        $element.on('click', e => {
            const $element = $(e.currentTarget);
            const value = $element.data('value');
            const searchValue = $element.data('search-value');
            const price = $element.data('price');
            const $target = $($element.data('target'));
            const $searchTarget = $($element.data('search-target'));
            if ($element.data('hide-modal')) {
                $element.closest('.modal').modal('hide');
            }
            if (searchValue) {
                $target.on('loaded', (e, data) => {
                    if (data.results[0].value) {
                        $target.dropdown('set selected', data.results[0] ? data.results[0].value : '');
                        $searchTarget.val('');
                        $target.data('price', price);
                        $target.trigger('change');
                    }
                });
                $searchTarget.val(searchValue);
                $searchTarget.trigger('keyup').trigger('change');
            }
            else if ($target.hasClass('dropdown')) {
                $target.data('price', price);
                $target.dropdown('set selected', value).trigger('change');
            }
            else {
                $target.val(value);
                $target.data('price', price);
                $target.trigger('keyup').trigger('change');
            }
        });
    }
}
